module.exports = __webpack_public_path__ + "img/img-bot.f608e47c.png";